import type { AppConfig } from '../app/core/config/app-config';

/** Configuración para el servidor de desarrollo. */
export const environment: AppConfig = {
  production: false,
  appName: 'ultratax',
  authApiBaseUrl: 'https://admin.utx.ittiva.com:2040/auth',
  tripApiBaseUrl: 'https://admin.utx.ittiva.com:2040/utx-core-trip-service',
  // Servicio de seguimiento vía gateway remoto. Para levantarlo en local (puerto 2032):
  // 'http://localhost:2032/utx-core-tracking-service'
  trackingApiBaseUrl: 'https://admin.utx.ittiva.com:2040/utx-core-tracking-service',
  adminApiBaseUrl: 'https://admin.utx.ittiva.com:2040/admin',
  supportApiBaseUrl: 'https://admin.utx.ittiva.com:2040/utx-ext-support-service',
  socialAuth: {
    googleClientId: '539522050014-h7ljkn6bt128uicsjpn84e0c7vab9q8b.apps.googleusercontent.com',
    facebookAppId: '',
  },
  googleMaps: {
    apiKey: 'AIzaSyBdEW3hI2EAouRRVWY8fgO7q_12tdUjQjc',
  },
  /**
   * Tiles del servidor público de OpenStreetMap.
   *
   * ⚠️ SOLO PARA DESARROLLO. La Tile Usage Policy de OSM prohíbe usar
   * `tile.openstreetmap.org` desde una app distribuida; hay que contratar un
   * proveedor (MapTiler, Stadia, Carto, Thunderforest) o autohospedar y poner
   * aquí su plantilla. Es infraestructura nuestra, no un pendiente del backend.
   */
  osmTiles: {
    tileUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap',
    maxZoom: 19,
  },
};
